/* eslint-disable import/no-anonymous-default-export */
import {
    SAVE_APPLY_LIST,
    DELETE_APPLY_LIST,
    SAVE_APPLY_CANCEL_LIST,
    DELETE_APPLY_CANCEL_LIST
} from '../_actions/types';

export default function (state = {dataList:[], dataCancelList: []}, action) {
    
    switch (action.type) {

        case SAVE_APPLY_CANCEL_LIST:

            const applyCancelList = action.payload.applyCancelList;
            
            return {...state, dataCancelList: applyCancelList}

        case DELETE_APPLY_CANCEL_LIST:

            const applicantKey = action.payload.applicantKey;
            const dataCancelList = action.payload.dataCancelList;
            const applyCancelListReplace = dataCancelList.filter( item =>
                item.applicantKey !== applicantKey
            )

            return {...state, dataCancelList: applyCancelListReplace}
        
        case SAVE_APPLY_LIST:

            const applyList = action.payload.applyList;
            const totalCount = action.payload.totalCount;

            return {...state, dataList: applyList, totalCount}
        
        case DELETE_APPLY_LIST:
         
            const isbn = action.payload.isbn;
            const dataList = action.payload.dataList;
            const totalCountAfterDelete = action.payload.totalCount;
            const applyListReplace = dataList.filter( item =>
                item.isbn !== isbn
            );

            return {...state, dataList: applyListReplace, totalCount: totalCountAfterDelete}
        default:
            return state;
    }
}